import { FileText, Logs } from "lucide-react";
import type { TaskVisibleFields } from "@shared/taskVisibleFields";

type Props = {
  visibleFields: TaskVisibleFields;
  colors: { bar: string; ink: string };
};

export default function PatternSupportPreview({
  visibleFields,
  colors,
}: Props) {
  if (!visibleFields.notes && !visibleFields.log) return null;

  return (
    <div className="ui-task-support-buttons">
      {visibleFields.notes && (
        <div
          className="ui-task-support-button"
          style={{ color: colors.ink, borderColor: colors.bar }}
        >
          <FileText
            className="h-4 w-4 shrink-0"
            style={{ color: colors.ink, opacity: 0.6 }}
            aria-hidden="true"
          />
          <span className="min-w-0 flex-1 truncate text-left">Edit note</span>
        </div>
      )}
      {visibleFields.log && (
        <div
          className="ui-task-support-button"
          style={{ color: colors.ink, borderColor: colors.bar }}
        >
          <Logs
            className="h-4 w-4 shrink-0"
            style={{ color: colors.ink, opacity: 0.6 }}
            aria-hidden="true"
          />
          <span className="min-w-0 flex-1 truncate text-left">Event log</span>
        </div>
      )}
    </div>
  );
}
